import { z } from "zod";
import { AgencyIdSchema } from "../primitives/ids.js";
import { PublicScanTopIssueV1Schema } from "./public-scan.js";
export const BatchAuditBatchIdSchema = z
    .string()
    .regex(/^bacth_[a-zA-Z0-9_-]+$/)
    .brand();
export const BatchAuditItemIdSchema = z
    .string()
    .regex(/^baitm_[a-zA-Z0-9_-]+$/)
    .brand();
export const BatchAuditStatusSchema = z.enum([
    "PENDING",
    "PROCESSING",
    "COMPLETE",
    "FAILED",
]);
export const BatchAuditItemStatusSchema = z.enum([
    "PENDING",
    "PROCESSING",
    "COMPLETE",
    "FAILED",
    "BLOCKED",
]);
/** Opportunity labels for batch audit ranking. */
export const BatchAuditOpportunityLabelSchema = z.enum([
    "QUICK_FIX",
    "FIX_KIT_CANDIDATE",
    "RELAUNCH_CANDIDATE",
    "PROOF_RELAUNCH_CANDIDATE",
    "OWNERSHIP_GAP",
    "LEAD_PATH_WEAK",
]);
export const BATCH_AUDIT_OPPORTUNITY_LABELS = [
    "QUICK_FIX",
    "FIX_KIT_CANDIDATE",
    "RELAUNCH_CANDIDATE",
    "PROOF_RELAUNCH_CANDIDATE",
    "OWNERSHIP_GAP",
    "LEAD_PATH_WEAK",
];
export const BatchAuditUploadRequestV1Schema = z
    .object({
    schemaVersion: z.literal("batch-audit-upload.v1.0"),
    urls: z.array(z.string().min(1).max(2048)).min(1).max(50),
})
    .strict();
export const BatchAuditUploadAcceptedV1Schema = z
    .object({
    schemaVersion: z.literal("batch-audit-upload-accepted.v1.0"),
    batchId: BatchAuditBatchIdSchema,
    status: z.literal("PENDING"),
    submittedCount: z.number().int().positive(),
})
    .strict();
export const BatchAuditItemViewV1Schema = z
    .object({
    itemId: BatchAuditItemIdSchema,
    submittedUrl: z.string().min(1),
    scannedUrl: z.string().url().optional(),
    status: BatchAuditItemStatusSchema,
    rank: z.number().int().positive().optional(),
    opportunityLabel: BatchAuditOpportunityLabelSchema.optional(),
    score: z.number().int().min(0).max(100).optional(),
    scoreLabel: z.string().min(1).optional(),
    topIssues: z.array(PublicScanTopIssueV1Schema).max(5).optional(),
    failureReason: z.string().min(1).optional(),
})
    .strict();
export const BatchAuditBatchViewV1Schema = z
    .object({
    schemaVersion: z.literal("batch-audit-batch-view.v1.0"),
    batchId: BatchAuditBatchIdSchema,
    agencyId: AgencyIdSchema,
    status: BatchAuditStatusSchema,
    submittedCount: z.number().int().nonnegative(),
    completedCount: z.number().int().nonnegative(),
    items: z.array(BatchAuditItemViewV1Schema),
    createdAt: z.string().datetime(),
    completedAt: z.string().datetime().optional(),
    failureReason: z.string().min(1).optional(),
})
    .strict();
export const BatchAuditBatchListV1Schema = z
    .object({
    schemaVersion: z.literal("batch-audit-batch-list.v1.0"),
    batches: z.array(z
        .object({
        batchId: BatchAuditBatchIdSchema,
        status: BatchAuditStatusSchema,
        submittedCount: z.number().int().nonnegative(),
        completedCount: z.number().int().nonnegative(),
        createdAt: z.string().datetime(),
    })
        .strict()),
})
    .strict();
//# sourceMappingURL=batch-audit.js.map